import {
    createAction,
} from '@shared/common';

const TYPE_NAMESPACE = 'UPLOAD';

export const start = createAction(
    `${TYPE_NAMESPACE}/START`,
    ({floor_id, files}) => ({floor_id, files}),
);

export const progress = createAction(
    `${TYPE_NAMESPACE}/PROGRESS`,
    progress => ({progress}),
);

export const success = createAction(
    `${TYPE_NAMESPACE}/SUCCESS`,
);

export const failure = createAction(
    `${TYPE_NAMESPACE}/FAILURE`,
    error => ({error}),
);

export const resetError = createAction(
    `${TYPE_NAMESPACE}/RESET_ERROR`,
);

export const floorplan = {
    start: createAction(
        `${TYPE_NAMESPACE}/FLOORPLAN/START`,
        ({floor_id, files}) => ({floor_id, files}),
    ),
    progress: createAction(
        `${TYPE_NAMESPACE}/FLOORPLAN/PROGRESS`,
        progress => ({progress}),
    ),
    success: createAction(
        `${TYPE_NAMESPACE}/FLOORPLAN/SUCCESS`,
    ),
    failure: createAction(
        `${TYPE_NAMESPACE}/FLOORPLAN/FAILURE`,
    ),
};

export const preview = {
    start: createAction(
        `${TYPE_NAMESPACE}/PREVIEW/START`,
        ({files}) => ({files}),
    ),
    progress: createAction(
        `${TYPE_NAMESPACE}/PREVIEW/PROGRESS`,
        progress => ({progress}),
    ),
    success: createAction(
        `${TYPE_NAMESPACE}/PREVIEW/SUCCESS`,
    ),
    failure: createAction(
        `${TYPE_NAMESPACE}/PREVIEW/FAILURE`,
    ),
};
